import React from 'react';
import { cn } from '../../lib/utils';
interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'outline' | 'success' | 'warning';
  className?: string;
  icon?: ReactNode;
}
export function Badge({
  children,
  variant = 'default',
  className,
  icon
}: BadgeProps) {
  const variants = {
    default: 'bg-slate-100 text-slate-800',
    outline: 'bg-transparent border border-slate-200 text-slate-600',
    success: 'bg-emerald-100 text-emerald-800',
    warning: 'bg-amber-100 text-amber-800'
  };
  return <span className={cn('inline-flex items-center px-3 py-1 rounded-full text-sm font-medium', variants[variant], className)} data-id="element-273">
      {icon && <span className="mr-1.5 -ml-0.5" data-id="element-274">{icon}</span>}
      {children}
    </span>;
}